import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API, graphqlOperation } from "aws-amplify";
import { listItemLotDetails } from "../../graphql/queries";
import { PURGE } from "redux-persist";

export const fetchItemLotDetails = createAsyncThunk(
  "ItemLotDetails/fetchItemLotDetails",
  async () => {
    try {
      const responseData = await API.graphql(
        graphqlOperation(listItemLotDetails)
      );
      return responseData?.data?.listItemLotDetails;
    } catch (error) {
      throw error;
    }
  }
);

// Initial state
const INITIAL_STATE = {
  itemLotData: [],
  rows: [],
  newRow: {
    lotNo: null,
    code: null,
    name: null,
    unit: null,
    qty: null,
    rate: null,
    balance: 0,
    action: null,
  },
  OpBalance: 0,
  render: true,
  loading: false,
  open: false,
};

const itemLotDetails = createSlice({
  name: "ItemLotDetails",
  initialState: INITIAL_STATE,
  reducers: {
    setItemLotRows: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    setRender: (state, action) => {
      state.render = action.payload;
    },
    updateItemLotRows: (state, action) => {
      const { key, value } = action.payload;
      state[key] = [...state[key], value];
    },
    setOpenItemLotModal: (state, action) => {
      const { openingBal, open } = action.payload;
      state.OpBalance = openingBal;
      state.open = open;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchItemLotDetails.fulfilled, (state, action) => {
        state.itemLotData = action.payload;
        state.loading = false;
      })
      .addCase(fetchItemLotDetails.pending, (state) => {
        state.render = false;
        state.loading = true;
      })
      .addCase(fetchItemLotDetails.rejected, (state, action) => {
        state.render = true;
        state.loading = false;
      })
      .addCase(PURGE, () => INITIAL_STATE);
  },
});

export const {
  setItemLotRows,
  setOpenItemLotModal,
  updateItemLotRows,
  setRender,
} = itemLotDetails.actions;
export default itemLotDetails.reducer;
